import UIIntersectionObserver from 'UIComponents/observer/UIIntersectionObserver';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const ScrollTrackingWrapper = ({
  scrollTrackingFn,
  children
}) => {
  return /*#__PURE__*/_jsx(UIIntersectionObserver, {
    renderContent: isIntersecting => {
      if (isIntersecting) {
        scrollTrackingFn();
      }
      return /*#__PURE__*/_jsx(_Fragment, {
        children: children
      });
    },
    onIntersectionChange: ({
      observer,
      entries
    }) => {
      if (entries[0].isIntersecting) {
        observer.disconnect();
      }
    }
  });
};
export default ScrollTrackingWrapper;